import { ENV } from "content-studio/src/config"

const log = ((enviornment = "dev") => {
    if (enviornment === "prod") return () => {}
    return (identifier, ...args) => {
        console.log(identifier, ...args)
    }
})(ENV)
export default log
